import { render } from "./UserFormFillShow.vue?vue&type=template&id=c1336da8"
import script from "./UserFormFillShow.vue?vue&type=script&lang=js"
export * from "./UserFormFillShow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__